import { StyleSheet } from '@react-pdf/renderer';

export const styles = StyleSheet.create({
  containerSignature: {
    marginTop: 18,
  },
  digitalSignatureContainer: {
    flexDirection: 'row',
    borderWidth: 1,
    borderColor: '#92d7b1',
    borderRadius: 8,
    overflow: 'hidden',
    minHeight: 82,
  },
  digitalSignatureLeft: {
    width: '34%',
    backgroundColor: '#eefaf3',
    paddingHorizontal: 10,
    paddingVertical: 8,
    justifyContent: 'center',
    alignItems: 'center',
    borderRightWidth: 1,
    borderRightColor: '#cbeedb',
  },
  digitalSignatureRight: {
    width: '66%',
    paddingHorizontal: 10,
    paddingVertical: 8,
    justifyContent: 'center',
  },
  digitalSignatureCertificate: {
    width: 36,
    height: 36,
    marginBottom: 4,
  },
  digitalSignatureBadge: {
    fontSize: 6.8,
    fontWeight: 700,
    color: '#1f7a4c',
    marginBottom: 4,
    textAlign: 'center',
    letterSpacing: 0.4,
  },
  digitalSignatureBadgeText: {
    fontSize: 6.8,
    color: '#2d8e5d',
    marginTop: 4,
    textAlign: 'center',
  },
  digitalSignatureTitle: {
    fontSize: 8.6,
    color: '#276749',
    marginBottom: 2,
  },
  digitalSignatureSigner: {
    fontSize: 11,
    fontWeight: 700,
    color: '#14532d',
    marginBottom: 2,
  },
  digitalSignatureMeta: {
    fontSize: 7.5,
    color: '#166534',
    marginBottom: 3,
  },
  digitalSignatureValidationCode: {
    fontSize: 7.4,
    color: '#14532d',
    marginBottom: 2,
  },
  digitalSignatureTimestamp: {
    fontSize: 7.4,
    color: '#14532d',
  },
  digitalSignatureImage: {
    width: '70%',
    maxHeight: 28,
    objectFit: 'contain',
  },
  digitalSignaturePlaceholder: {
    fontSize: 24,
    color: '#97d7b4',
    textAlign: 'center',
  },
  rowContainer: {
    display: 'flex',
    alignItems: 'center',
    borderBottomWidth: 1,
    marginHorizontal: 100,
  },
  signatureText: {
    textAlign: 'center',
    fontSize: 15,
  },
  terminologyText: {
    textAlign: 'center',
    fontSize: 12,
  },
  rqeText: {
    textAlign: 'center',
    fontSize: 10,
  },
  validationCodeText: {
    marginTop: 6,
    textAlign: 'center',
    fontSize: 9,
  },
  digitalSignatureValidationUrl: {
    fontSize: 7,
    color: '#166534',
    marginTop: 3,
  },
  validationUrlText: {
    marginTop: 4,
    textAlign: 'center',
    fontSize: 8,
    color: '#1f7a4c',
  },
});
